export function useJoinOptions() {
    const clearJoinOptions = () => {
        localStorage.removeItem('blue_join_options_source');
        localStorage.removeItem('blue_join_options_join_type');
        localStorage.removeItem('blue_join_options_url');
        localStorage.removeItem('blue_join_options_video_props');
        localStorage.removeItem('gold_upgrade_source');
        localStorage.removeItem('gold_upgrade_video_id');
        console.log('++ Clear Join Options');
    }

    // Make it available globally for components that need window.clearJoinOptions
    if (typeof window !== 'undefined') {
        window.clearJoinOptions = clearJoinOptions
    }

    return {
        clearJoinOptions
    }
}
